<template>
  <footer class="bg-dark text-light py-4">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6">
          <p class="mb-0">&copy; {{ currentYear }} {{ firstName }} {{ lastName }}. All rights reserved.</p>
        </div>
        <div class="col-md-6 text-md-end">
          <div class="social-icons">
            <a class="social-icon text-light me-3" href="https://www.linkedin.com/in/yipingche/" aria-label="LinkedIn" target="_blank" rel="noopener">
              <i class="fab fa-linkedin-in"></i>
            </a>
            <a class="social-icon text-light" href="https://github.com/cypecial" aria-label="GitHub" target="_blank" rel="noopener">
              <i class="fab fa-github"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
    firstName() {
      return this.$t('profile.firstName');
    },
    lastName() {
      return this.$t('profile.lastName');
    }
  }
};
</script>

<style scoped>
.social-icon {
  text-decoration: none;
  transition: opacity 0.3s ease;
}
.social-icon:hover {
  opacity: 0.7;
}
</style> 